import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import Debug from 'debug';

const debug = Debug('aumico:core:EmptyDataGridFeedback');

@Component({
    selector: 'empty-data-grid-feedback',
    templateUrl: 'empty-data-grid-feedback.component.html',
    styleUrls: ['empty-data-grid-feedback.component.scss'],
})
export class EmptyDataGridFeedbackComponent implements OnInit {
    showInformationMessage = true;
    taskListCheck2SvgPath = '../../../../assets/icons/task-list-check 2.svg';
    interfaceDeleteSvgPath = '../../../../assets/icons/interface-delete 1.svg';

    constructor() {}

    ngOnInit(): void {}
}
